// removed by extract-text-webpack-plugin
module.exports = {"scaleLine":"LinePercentScale__scaleLine___mPMBW","percent25":"LinePercentScale__percent25___371xc","values":"LinePercentScale__values___1sWkH","lineValue":"LinePercentScale__lineValue___2-l64"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StackedBarChart/LinePercentScale/LinePercentScale.less
// module id = 1239
// module chunks = 0